<input class="mc-hidden" type="file" [accept]="accept" [disabled]="disabled" [multiple]="multiple" #fileInput (change)="onFileChanged($event)">

<ng-container *ngIf="!empty || !placeholder; else emptyPlaceholder">
  <mat-chip-set class="mc-file-picker-chip-list">
    <mat-chip *ngFor="let file of value; let index = index" class="mc-file-picker-chip" [removable]="true" (removed)="onFileChipRemoved(index)">
      <mc-self-truncating-path class="mc-file-picker-value" [filePath]="isPathWithLeadingSlash ? (file.filePath | mcRemoveLeadingSlash) : file.filePath"></mc-self-truncating-path>
      <button matChipRemove [attr.aria-label]="'Remove ' + (isPathWithLeadingSlash ? (file.filePath | mcRemoveLeadingSlash) : file.filePath)">
        <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
      </button>
    </mat-chip>
  </mat-chip-set>
</ng-container>
<ng-template #emptyPlaceholder>
  <mc-self-truncating-path class="mc-file-picker-placeholder" [filePath]="placeholder"></mc-self-truncating-path>
</ng-template>